module.exports = __webpack_public_path__ + "static/media/productCurvyLines.b1026567.png";